// Seed data — used both as (a) initial state for useInventoryStore
// before the /api/inventory/config bootstrap resolves, and (b) fallback
// defaults for every destructuring of useInv() so the page keeps
// rendering even if the backend is momentarily unreachable.

export const SEED_TEAMS = [
  { key: "outreach1", label: "Outreach (George)" },
  { key: "outreach2", label: "Outreach (Racquel)" },
  { key: "outreach3", label: "Outreach (Malachi)" },
];

export const SEED_SUPPLIERS = [
  { id: "s1", company: "MediSupply Co.",         first: "Alicia",  last: "Nguyen",  tel: "(514) 555-0134", email: "orders@medisupply.ca",   instructions: "Ship weekly on Tuesdays. Reception 8–4 only.",  items: 12 },
  { id: "s2", company: "SafePoint Distributors", first: "Marcus",  last: "Green",   tel: "(438) 555-2018", email: "marcus@safepoint.co",    instructions: "Requires PO number in the subject line.",       items: 7 },
  { id: "s3", company: "Northern Rapid Labs",    first: "Priya",   last: "Sharma",  tel: "(514) 555-9971", email: "priya.sharma@nrl-labs.ca", instructions: "Refrigerated shipment — signature on delivery.", items: 4 },
];

export const SEED_CATALOGUE = [
  // min/max = per-team thresholds (drives "Needed" on the count sheet).
  // hqMin/hqMax = warehouse thresholds (drives "Reorder from supplier"
  // on the HQ Receiving screen). Rule of thumb: HQ carries roughly
  // teams × team-max as a buffer, but tweakable per item.
  { id: "i1", supplier: "s1", name: "HCV Rapid Test Kit",       code: "HCV-RTK-25", pack: "Box",  packQty: 25,  min: 4, max: 12, hqMin: 16, hqMax: 40 },
  { id: "i2", supplier: "s1", name: "Alcohol Swabs (Sterile)",  code: "SWB-100",    pack: "Pack", packQty: 100, min: 6, max: 20, hqMin: 24, hqMax: 60 },
  { id: "i3", supplier: "s1", name: "Sharps Container 1L",      code: "SHARP-1L",   pack: "Each", packQty: 1,   min: 8, max: 24, hqMin: 30, hqMax: 80 },
  { id: "i4", supplier: "s2", name: "Butterfly Needles 21G",    code: "BFN-21G",    pack: "Box",  packQty: 50,  min: 3, max: 10, hqMin: 12, hqMax: 30 },
  { id: "i5", supplier: "s2", name: "Vacutainer EDTA",          code: "VT-EDTA",    pack: "Pack", packQty: 100, min: 5, max: 15, hqMin: 18, hqMax: 45 },
  { id: "i6", supplier: "s3", name: "Cold Chain Cooler Bag",    code: "CCB-M",      pack: "Each", packQty: 1,   min: 2, max: 6,  hqMin: 8,  hqMax: 16 },
  { id: "i7", supplier: "s3", name: "Ice Packs (Reusable)",     code: "IP-STD",     pack: "Pack", packQty: 6,   min: 4, max: 12, hqMin: 16, hqMax: 36 },
];

// HQ stock levels — some items are intentionally below hqMin so the mock
// surfaces the "Reorder from supplier" flow (i4 Butterfly Needles at 12
// vs hqMin 12 borderline, i6 Cooler Bag at 5 vs hqMin 8).
export const SEED_HQ_STOCK   = { i1: 32, i2: 18, i3: 40, i4: 12, i5: 26, i6: 5,  i7: 20 };
export const SEED_TEAM_STOCK = {
  outreach1: { i1: 4, i2: 5, i3: 22, i4: 2, i5: 9,  i6: 1, i7: 12 },
  outreach2: { i1: 3, i2: 3, i3: 18, i4: 7, i5: 12, i6: 2, i7: 6  },
  outreach3: { i1: 0, i2: 0, i3: 0,  i4: 0, i5: 0,  i6: 0, i7: 0  },
};

export const SEED_REQUESTS = [
  { id: "r-42", team: "outreach1", item: "i1", qty: 8, reason: "Community screening event this Saturday.", submittedBy: "Christian", at: "Aug 3 · 09:14", status: "pending" },
  { id: "r-41", team: "outreach2", item: "i4", qty: 5, reason: "Below min after last outreach run.",       submittedBy: "Joséphine", at: "Aug 3 · 08:47", status: "pending" },
  { id: "r-40", team: "outreach1", item: "i6", qty: 2, reason: "Cold chain van refresh.",                  submittedBy: "Christian", at: "Aug 3 · 08:30", status: "pending" },
  { id: "r-39", team: "outreach2", item: "i2", qty: 6, reason: "Restocking Van 2.",                        submittedBy: "Joséphine", at: "Aug 2 · 17:02", status: "approved", approvedBy: "Olivier", movedAt: "Aug 2 · 17:04" },
  { id: "r-38", team: "outreach1", item: "i5", qty: 4, reason: "",                                         submittedBy: "Christian", at: "Aug 2 · 14:11", status: "approved", approvedBy: "Olivier", movedAt: "Aug 2 · 14:20" },
  { id: "r-37", team: "outreach2", item: "i3", qty: 2, reason: "Duplicate — already ordered.",             submittedBy: "Joséphine", at: "Aug 1 · 10:44", status: "denied",   approvedBy: "Olivier" },
];

export const SEED_RECEIPTS = [
  { id: "rc-9", date: "Aug 2, 2026", supplier: "s1", item: "i1", qty: 12, po: "PO-2026-081", receivedBy: "Olivier" },
  { id: "rc-8", date: "Aug 2, 2026", supplier: "s1", item: "i2", qty: 10, po: "PO-2026-081", receivedBy: "Olivier" },
  { id: "rc-7", date: "Jul 26, 2026", supplier: "s2", item: "i4", qty: 8,  po: "PO-2026-074", receivedBy: "Olivier" },
  { id: "rc-6", date: "Jul 26, 2026", supplier: "s3", item: "i6", qty: 4,  po: "PO-2026-075", receivedBy: "Olivier" },
];

// Last month's Start count — used for "was" reference on the count sheet.
export const SEED_LAST_MONTH_START = {
  outreach1: { i1: 12, i2: 20, i3: 24, i4: 8, i5: 14, i6: 4, i7: 12 },
  outreach2: { i1: 10, i2: 18, i3: 22, i4: 6, i5: 12, i6: 3, i7: 10 },
  outreach3: { i1: 0,  i2: 0,  i3: 0,  i4: 0, i5: 0,  i6: 0, i7: 0  },
};

export const today = new Date().toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });

export const teamLabel    = (k, teams = SEED_TEAMS) => teams.find((t) => t.key === k)?.label || (k === "hq" ? "HQ" : k);
export const catItem      = (id, catalogue = SEED_CATALOGUE) => catalogue.find((c) => c.id === id);
export const supplierName = (id, suppliers = SEED_SUPPLIERS) => suppliers.find((s) => s.id === id)?.company || id;
